/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'
import {Timeslot} from 'types/entities/Timeslot'
import BookingTimeslot from 'pages/Front/Booking/components/BookingTimeslots/BookingTimeslot'
import Dates from "utils/Dates";

interface UiOfferTimeslotItemProps {
    slot: Timeslot
    index: number
    selectedTimeslot: Timeslot | null
    onSelect: (timeslot: Timeslot) => void
}

const UiOfferTimeslotItem: React.FC<UiOfferTimeslotItemProps> = ({
    slot,
    index,
    selectedTimeslot,
    onSelect,
}) => {
    const isSelected = selectedTimeslot?.id === slot.id
	const today = new Date();
	const slotDate = new Date(slot.start_at);
	const daysDiff = Dates.daysDifference(slotDate, today)
	const isDisabled = daysDiff < 0;

    return (
        <BookingTimeslot
            key={slot.id}
            disabled={isDisabled}
            index={index}
            customTimeslotIndex={-1}
            firstPossibleSlotIndex={null}
            lastPossibleSlotIndex={null}
            timeslot={slot}
            packageRespectsTimeslotSize={null}
            selectedTimeslot={selectedTimeslot}
            onClick={() => onSelect(slot)}
            fakeTimeslotMinute={false}
            possibleTimeslotIndex={-1}
            possibleTimeslotsLength={0}
            showTimeslotOccupancy={false}
            showEventHoursCategory={true}
            className={clsx(
                'UiOfferTimeslotItem border-gray-300 dark:border-gray-800 bg-white dark:bg-gray-950',
                'hover:border-black dark:hover:border-gray-400',
                isSelected && 'ring-2 ring-blue-500 border-blue-500 dark:ring-blue-400 dark:border-blue-400 shadow-lg'
            )}
        />
    )
}

export default UiOfferTimeslotItem
